import { pannelStyles } from './uiStyles';

export const onCreatePanel = () => {
  // Create a style element for CSS
  pannelStyles();

  // Create the panel element
  const panel = document.createElement('div');
  panel.className = 'validator-panel';

  // Create the header for the panel
  const panelHeader = document.createElement('div');
  panelHeader.className = 'validator-panel-header';

  // Create the expand/collapse button
  const toggleButton = document.createElement('button');
  toggleButton.textContent = 'Expand';
  toggleButton.className = 'validator-panel-toggle-btn';

  // Create the close button
  const closeButton = document.createElement('button');
  closeButton.textContent = 'Close';
  closeButton.className = 'validator-panel-close-btn';

  // Create the content area
  const panelContent = document.createElement('div');
  panelContent.className = 'validator-panel-content';
  panelContent.innerHTML = `<h2>Events Validation</h2>
                            <p> This panel will help you to do validation b/w GA and Godavari events</p>
                            <div id="panel_summary_body"></div>
                            <div class="panel_tables_body" id="panel_events_body"></div>`;

  // Append buttons to the header
  panelHeader.appendChild(toggleButton);
  panelHeader.appendChild(closeButton);

  // Append header and content to the panel
  panel.appendChild(panelHeader);
  panel.appendChild(panelContent);

  // Append the panel to the body
  document.body.appendChild(panel);

  // Event listener for the toggle button
  toggleButton.addEventListener('click', function () {
    panel.classList.toggle('expanded');
    if (panel.classList.contains('expanded')) {
      toggleButton.textContent = 'Collapse'; // Change button text to Collapse
    } else {
      toggleButton.textContent = 'Expand'; // Change button text to Expand
    }
  });

  // Event listener for the close button
  closeButton.addEventListener('click', function () {
    panel.style.display = 'none'; // Hide the panel
  });
};
